var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{staticClass:"max-container"},[_c('CustomMenu'),_c('v-tabs',[_c('v-tab',[_vm._v("Links Pendientes")]),_c('v-tab',[_vm._v("Links con Pagos")]),_c('v-tab-item',[_c('ListPlan',{attrs:{"typeview":"pendiente"}})],1),_c('v-tab-item',[_c('ListPlan',{attrs:{"typeview":"con_pago"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }